import React from 'react';
import parse from 'html-react-parser';
import './MaintenanceAlert.css';

const MaintenanceAlert = ({ onClose, message, title }) => {
  return (
    <div className="maintenance-alert">
      <div className="maintenance-content">
        <h3 className="maintenance-heading">{title || "System Maintenance Alert"}</h3>
        <div className="maintenance-message">
          {parse(message || '')}
        </div>
        <button className="maintenance-button" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default MaintenanceAlert;